export let MEDIA_TYPES;
(function (MEDIA_TYPES) {
  MEDIA_TYPES["SECURE_VIDEO"] = "secure_video";
  MEDIA_TYPES["PICTURE"] = "picture";
  MEDIA_TYPES["VIDEO"] = "video";
})(MEDIA_TYPES || (MEDIA_TYPES = {}));
//# sourceMappingURL=media-types.js.map